

















import Vue from "vue";
import Component from "vue-class-component";
import { CrudService } from "../core/services/crudService";
import { Settings, SettingsService } from "../core/services/configService";
import { CustomerHelper } from "../crm/helpers/customerHelper";
import { ProgramPackTexts } from "./programPackTexts";
import ProgramPage from "../components/programs/ProgramPage.vue";
import ProgramPill from "../components/programs/ProgramPill.vue";
import ProgramMeta from "../components/programs/ProgramMeta.vue";
import ProgramProgress from "../components/programs/ProgramProgress.vue";

@Component({
  components: { ProgramPage, ProgramPill, ProgramMeta, ProgramProgress },
})
export default class MyProgramPacksPage extends Vue {
  enrollments: any[] = [];
  loaded: boolean = false;
  texts = ProgramPackTexts;

  get emptyText(): string {
    return this.loaded && this.enrollments.length === 0 ? this.$t("You do not have any program yet").toString() : "";
  }

  t(key: string): string {
    return this.$t(key).toString();
  }

  async mounted() {
    new SettingsService().setPageTitle(this.t("Your Programs"));
    const url = `${Settings.HostName}/api/publicprogrampacks/customer/${CustomerHelper.getStoredCustomer()}`;
    const data = await new CrudService().httpGet(url);
    this.enrollments = data && data.ok ? data.data : [];
    this.loaded = true;
  }
}
